import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import SchoolsPage from 'pages/ShipplayCollegeMovingServicesPage';

const SchoolsPages = () => (
  <Router>
    <Switch>
      <Route
        exact path="/ship-schools"
        render={(props) => (
          <SchoolsPage
            {...props}
            quickQuoteTitle="Get a quote now and book online."
            termsConditionsText="Our dedicated customer support team is here for you every single day of the week. Should you have any questions or need additional information, please call or text us at (855) 792-7529."
          />
        )}
      />
    </Switch>
  </Router>
);

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<SchoolsPages />, document.body.appendChild(document.createElement('div')))
});
